import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoFW from '../components/LogoFW';
import RightMenu from '../components/RightMenu';
import Line from '../components/Line';
import { AnkietaContext } from '../Context/PollSystem';
import styles from '../style/style.scss';
import img1winko from '../images/ankietabg/1winko.jpg';
import img2kolor from '../images/ankietabg/2kolor.jpg';
import img3wytra from '../images/ankietabg/3wytrawne.jpg';
import img4cena from '../images/ankietabg/4cena.jpg';
import img5okazja from '../images/ankietabg/5okazja.jpg';
import img6kraj from '../images/ankietabg/6kraj.jpg';
import { ProductInfoPage } from '../components/ProductInfoPage';
import HiddenInput from '../components/HiddenInput';

function LoadAllBgImg() {
  return (
    <div
      style={{
        position: 'absolute',
        top: '9000px',
      }}
    >
      <img src={img1winko} alt="" />
      <img src={img2kolor} alt="" />
      <img src={img3wytra} alt="" />
      <img src={img4cena} alt="" />
      <img src={img5okazja} alt="" />
      <img src={img6kraj} alt="" />
    </div>
  );
}

function JoinPoll1({ gotToNextQuestion }: { gotToNextQuestion(): void }) {
  const conatinerStyle: React.CSSProperties = {
    padding: '0px',
    background: `url(${img1winko})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  };
  const navigate = useNavigate();

  useEffect(() => {
    // wyczyść ankiete (nic nie podświetlaj, nic nie ukrywaj)
    fetch('/api/v1/product_glow/', {
      method: 'POST',
      body: JSON.stringify([]),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });
  }, []);
  return (
    <div className={styles.fwcontainer} style={conatinerStyle}>
      <LoadAllBgImg />
      <HiddenInput
        getProductEanCallback={(ean_code: string) => {
          navigate(`/app?product=${ean_code}`);
        }}
      />
      <div className={styles.verticalCenter}>
        <div
          onClick={() => {
            navigate('/app');
          }}
        >
          <LogoFW style={{ height: '300px' }} />
        </div>
        <div className="mb-5" />
        <h1 className="text-center" style={{ fontSize: '70px' }}>
          Pomożemy wybrać najlepsze wino dla Ciebie
        </h1>
        <div className="mb-5" />
        <Line />
        <div className="mb-5" />
        <button type="button" className={styles.pollButton} onClick={gotToNextQuestion}>
          Kilknij!
        </button>
      </div>
    </div>
  );
}

function PollResult({ goToQuestion }: { goToQuestion(qid: number): void }) {
  const [displayEanCode, setDisplayEanCode] = useState<string | null>(null);
  const { findBestProduct, findSuggestedProducts, savePollData } = useContext(AnkietaContext);
  const [bestProductList, setBestProductList] = useState<string[]>(findBestProduct());
  const [suggestedProductList, setSuggestedProductList] = useState<string[]>([]);
  const [page, setPage] = useState<number>(1);
  const [showNotFound, setShowNotFound] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (bestProductList.length == 0) {
      setDisplayEanCode(null);
      setShowNotFound(true);
      setPage(0);
    } else {
      setDisplayEanCode(bestProductList[page - 1]);
      goToQuestion(6); // update time
    }
  }, [page]);

  useEffect(() => {
    console.log('savePollData');
    savePollData();
  }, [bestProductList]);

  const goToSuggestedProductList = () => {
    const pList = findSuggestedProducts();
    console.log(pList);
    setBestProductList(pList)
    setPage(1);
    setDisplayEanCode(pList[0]);
    setShowNotFound(false);
    goToQuestion(6); // update time
  }

  return (
    <div className={styles.productpreview}>
      <HiddenInput
        getProductEanCallback={(ean_code: string) => {
          navigate(`/app?product=${ean_code}`);
        }}
      />
      {!showNotFound && (
        <>
          <div className={styles.productpreviewframe} style={{ transform: 'scale(0.85)' }}>
            {displayEanCode && <ProductInfoPage ean_code={displayEanCode} eventName="poll_gallery" galleryFix={true} />}
          </div>
          <div className={styles.productpreviewbuttons}>
            <div style={{ width: '20%' }}>
              <button
                type="button"
                className={styles.pollNavigationBtn}
                style={{ marginLeft: '140px', display: page > 1 ? 'block' : 'none' }}
                onClick={() => setPage(page - 1)}
              >
                Poprzedni
              </button>
            </div>
            <button
              type="button"
              className={styles.pollNavigationBtn}
              style={{ margin: 'auto', width: '380px' }}
              onClick={() => goToQuestion(0)}
            >
              Rozpocznij od nowa
            </button>
            <div style={{ width: '12%' }}>
              <button
                type="button"
                className={styles.pollNavigationBtn}
                style={{ display: page < bestProductList.length ? 'block' : 'none' }}
                onClick={() => setPage(page + 1)}
              >
                Następny
              </button>
            </div>
            <div style={{ width: '16%', textAlign: 'right', marginRight: '20px' }}>
              {page != 0 && (
                <h2>
                  {page} z {bestProductList.length}
                </h2>
              )}
            </div>
          </div>
        </>
      )}

      {showNotFound && (
        <div
          style={{
            padding: '120px',
            textAlign: 'center',
            width: '100%',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            color: 'white',
          }}
        >
          <h2 style={{ fontSize: '60px', marginBottom: '90px' }}>
            Ups, wygląda na to, że nie mamy wina którego szukasz
          </h2>
          <div style={{ marginBottom: '30px' }}>
            <button
              type="button"
              className={styles.pollNavigationBtn}
              style={{ margin: 'auto', width: '380px' }}
              onClick={() => goToQuestion(0)}
            >
              Rozpocznij od nowa
            </button>
            <div style={{ width: '60px', display: 'inline-block' }}></div>
            <button
              type="button"
              className={styles.pollNavigationBtn}
              style={{ margin: 'auto', width: '380px' }}
              onClick={() => goToQuestion(5)}
            >
              Cofnij
            </button>
          </div>
          <div>
            <button
              type="button"
              className={styles.pollNavigationBtn}
              style={{ margin: 'auto', width: '380px' }}
              onClick={() => goToSuggestedProductList()}
            >
              Nasze propozycje
            </button>
          </div>
        </div>
      )}

      <RightMenu goToQuestion={goToQuestion} activeQuestionId={6} />
    </div>
  );
}

function AnswerButton({
  text,
  qid,
  aid,
  resetRedirectDelay,
}: {
  text: string;
  qid: number;
  aid: number;
  resetRedirectDelay(): void;
}) {
  const { changeAnswer, getAnswer } = useContext(AnkietaContext);
  const [active, setActive] = useState(getAnswer(qid, aid));
  const clickHandler = () => {
    setActive(!active);
    resetRedirectDelay();
    changeAnswer(qid, aid, !active);
  };
  const activeClass = active ? styles.pollButtonActive : '';
  return (
    <button type="button" className={`${styles.pollButton} ${activeClass}`} onClick={clickHandler}>
      {text}
    </button>
  );
}

function PominBtn({ onClick }: { onClick(): void }) {
  return (
    <button type="button" className={`${styles.pollNavigationBtn} ${styles.skip}`} onClick={onClick}>
      Pomiń
    </button>
  );
}

function DalejBtn({ onClick }: { onClick(): void | undefined }) {
  return (
    <button type="button" className={`${styles.pollNavigationBtn} ${styles.forward}`} onClick={onClick}>
      Dalej
    </button>
  );
}

function CofnijBtn({ onClick }: { onClick(): void | undefined }) {
  return (
    <button type="button" className={`${styles.pollNavigationBtn} ${styles.back}`} onClick={onClick}>
      Cofnij
    </button>
  );
}

interface PollQuestionProps {
  qid: number;
  choices: Array<string>;
  title: string;
  bgImg: string;
  goToQuestion(qid: number): void;
  resetRedirectDelay(): void;
}

function PoolQuestion({ qid, choices, title, bgImg, goToQuestion, resetRedirectDelay }: PollQuestionProps) {
  const conatinerStyle: React.CSSProperties = {
    padding: '0px',
    background: `url(${bgImg})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  };
  const navigate = useNavigate();

  return (
    <div className={styles.fwcontainer} style={conatinerStyle}>
      <HiddenInput
        getProductEanCallback={(ean_code: string) => {
          navigate(`/app?product=${ean_code}`);
        }}
      />
      <div className={styles.pollNavigationBar}>
        <PominBtn onClick={() => goToQuestion(qid + 1)} />
        <div style={{ zIndex: '9999' }}>
          <CofnijBtn onClick={() => goToQuestion(qid - 1)} />
          <DalejBtn onClick={() => goToQuestion(qid + 1)} />
        </div>
        <div className={styles.message}>Wybrane wina podświetlają się na listwach</div>
      </div>
      <div className={styles.verticalCenter}>
        <h1 className="text-center fw-bold">{title}</h1>
        <div style={{ height: '10px' }} />
        <Line />
        <div style={{ height: '50px' }} />

        <div className={styles.pollChoiceContainer}>
          {choices.map((text, aid) => (
            <div className={styles.pollChoiceItem} key={text}>
              <AnswerButton text={text} qid={qid} aid={aid} resetRedirectDelay={resetRedirectDelay} />
            </div>
          ))}
        </div>
        <div style={{ height: '50px' }} />
      </div>
      <RightMenu goToQuestion={goToQuestion} activeQuestionId={qid} />
    </div>
  );
}

function AnkietaPage() {
  const BaseDelay = 60;
  const [questionId, setQuestion] = useState(0);
  const [count, setCount] = useState(10);
  const navigate = useNavigate();
  useEffect(() => {
    if (count === 0) navigate('/app');
    const t = setTimeout(() => setCount(count - 1), 1000);
    console.log(`Redirect to app after ${count} sec`);
    return () => clearTimeout(t);
  }, [count]);
  const resetRedirectDelay = () => setCount(BaseDelay);
  const { resetAnswers, getPollQuestions } = useContext(AnkietaContext);
  const goToQuestion = (qId: number) => {
    resetRedirectDelay();
    setQuestion(qId);
    // clear future answers
    resetAnswers(qId);
  };

  if (questionId === 0) {
    return (
      <JoinPoll1
        gotToNextQuestion={() => {
          // reset all answers
          resetAnswers(-1);
          goToQuestion(1);
        }}
      />
    );
  }

  if ([1, 2, 3, 4, 5].includes(questionId)) {
    const answers = getPollQuestions(questionId);
    if (answers) {
      return (
        <PoolQuestion
          key={answers.title}
          qid={questionId}
          title={answers.title}
          choices={answers.choices}
          bgImg={answers.bgImg}
          goToQuestion={goToQuestion}
          resetRedirectDelay={resetRedirectDelay}
        />
      );
    }
    goToQuestion(0);
  }
  return <PollResult goToQuestion={goToQuestion} />;
}

export default AnkietaPage;
